
import { LucideIcon } from 'lucide-react'

export interface SettingRowProps {
    Icon: LucideIcon
    title: string
    description?: string
    titleExtraElement?: React.ReactNode
    children: React.ReactNode
}

export const SettingRow = ({ Icon, title, description, titleExtraElement, children }: SettingRowProps) => {
    return (
        <div className="flex items-center justify-between py-3 gap-4">
            <div className="flex items-center gap-4">
                <Icon className="w-5 h-5 shrink-0 text-primary" />
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-1.5">
                        <p className="font-medium text-foreground">{title}</p>
                        {titleExtraElement}
                    </div>
                    {description && <p className="text-sm text-muted-foreground">{description}</p>}
                </div>
            </div>
            <div className="flex items-center">
                {children}
            </div>
        </div>
    )
}

